// extracted by mini-css-extract-plugin
export default {"logoWrapper":"styles_logoWrapper__dRz+F","logo":"styles_logo__Mk7YG"};